import type { ExportFormat, ExportQuality } from '@k2/domain/exports'
import { useApi } from '@/api'

export type ExportRequest = { format: ExportFormat; scale: number; quality?: ExportQuality }

export const useExportsResource = () => {
  const api = useApi()
  const deliverableOf = (organizationId: string, deliverableId: string) =>
    api.api.v1.organizations({ organizationId }).deliverables({ deliverableId })

  return {
    getExports: (organizationId: string, deliverableId: string) => deliverableOf(organizationId, deliverableId).exports.get(),
    startExport: (organizationId: string, deliverableId: string, request: ExportRequest) =>
      deliverableOf(organizationId, deliverableId).export.post(request),
    getExportSlides: (organizationId: string, exportId: string) =>
      api.api.v1.organizations({ organizationId }).exports({ exportId }).slides.get(),
    publish: (organizationId: string, deliverableId: string) => deliverableOf(organizationId, deliverableId).publish.post()
  }
}
